import PropTypes from 'prop-types';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import _ from 'lodash';
import { translate as t } from '../../lib/I18n';

function splitParagraphs (input, tagName = 'p') {
    const paragraphs = input.split("\n")
        .map((line) => `<${tagName}>${line.trim()}</${tagName}>`);
    return paragraphs.join("");
}

// What follows is from react-intl adapted to use our dictionary
/*
Copyright 2014 Yahoo Inc.
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.

    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.

    * Neither the name of the Yahoo Inc. nor the
      names of its contributors may be used to endorse or promote products
      derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL YAHOO! INC. BE LIABLE FOR ANY
DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
class FormattedHTMLMessage extends React.PureComponent {
    static propTypes = {
        tagName: PropTypes.string,
        className: PropTypes.string,
        message: PropTypes.string.isRequired,
        splitParagraphs: PropTypes.bool,
        paragraphTagName: PropTypes.string
    };

    static defaultProps = {
        tagName: 'span',
        className: null,
        splitParagraphs: false,
        paragraphTagName: 'p'
    };

    render() {
        var props = this.props;
        var tagName = props.tagName;
        var message = props.message;
        let onClickHandler = null;

        // Process all the props before they are used as values when formatting
        // the ICU Message string. Since the formatted message will be injected
        // via `innerHTML`, all String-based values need to be HTML-escaped. Any
        // React Elements that are passed as props will be rendered to a static
        // markup string that is presumed to be safe.
        var messageValues = Object.keys(props).reduce(function (values, name) {
            var value = props[name];

            if (typeof value === 'string') {
                value = _.escape(value);
            } else if (React.isValidElement(value)) {
                onClickHandler = value.props.onClick ? value.props.onClick : null;
                value = ReactDOMServer.renderToStaticMarkup(value);
            }

            values[name] = value;
            return values;
        }, {});

        let html = t(message, messageValues);
        if (this.props.splitParagraphs) {
            html = splitParagraphs(html, this.props.paragraphTagName);
        }

        // Since the message presumably has HTML in it, we need to set
        // `innerHTML` in order for it to be rendered and not escaped by React.
        // To be safe, all string prop values were escaped before formatting the
        // message. It is assumed that the message is not UGC, and came from
        // the developer making it more like a template.
        //
        // Note: There's a perf impact of using this component since there's no
        // way for React to do its virtual DOM diffing.
        return React.createElement(tagName, {
            className: this.props.className,
            onClick: onClickHandler,
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}

export default FormattedHTMLMessage;
